import axios from "../utils/axios";

class AuthService{
    login(data){
        return axios.post("login", data);
    }
}
export const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }; 
export default new AuthService();